import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SharedUiAddGuardianModule } from '@se-po/shared-ui-add-guardian'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeIconModule, seFeIconSpotHousehold } from 'se-fe-icon'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { HouseholdInviteComponent } from './household-invite/household-invite.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeHeaderModule,
    SeFeIconModule.include([seFeIconSpotHousehold]),
    SharedUiAddGuardianModule,
    SharedUiHighlightLabelModule,
    SeFeTranslationsModule,
  ],
  declarations: [HouseholdInviteComponent],
  exports: [HouseholdInviteComponent],
})
export class SharedFeatureHouseholdInviteModule {}
